import EditCustomer from "./EditCustomer";
import './editCustomer.scss';

export default EditCustomer;